import { render } from "./AcceptTermsDialog.vue?vue&type=template&id=74d30584"
import script from "./AcceptTermsDialog.vue?vue&type=script&lang=js"
export * from "./AcceptTermsDialog.vue?vue&type=script&lang=js"

import "./AcceptTermsDialog.vue?vue&type=style&index=0&id=74d30584&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__